import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from 'services/auth';

const PasswordResetForm = ({ hasLabel }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  // Verificar que se tenga un token válido
  if (!token) {
    return <div>Error: No se proporcionó un token válido.</div>;
  }

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();

    // Validar que las contraseñas coincidan
    if (newPassword !== confirmPassword) {
      toast.error('Las contraseñas no coinciden.');
      return;
    }

    // Enviar solicitud al backend
    try {
      const response = await resetPassword(token, newPassword);
      if (response.success) {
        toast.success('Contraseña restablecida con éxito. Inicia sesión.', {
          theme: 'colored'
        });
        navigate('/authentication/simple/login');
      } else {
        toast.error(response.message || 'Error al restablecer la contraseña.');
      }
    } catch (error) {
      toast.error('Error al restablecer la contraseña. Intenta de nuevo.');
    }
  };

  return (
    <Form
      className={classNames('mt-3', { 'text-left': hasLabel })}
      onSubmit={handleSubmit}
    >
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Nueva Contraseña</Form.Label>}
        <Form.Control
          placeholder="Nueva Contraseña"
          value={newPassword}
          name="password"
          onChange={({ target }) => setNewPassword(target.value)}
          type="password"
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Confirmar Contraseña</Form.Label>}
        <Form.Control
          placeholder="Confirmar Contraseña"
          value={confirmPassword}
          onChange={({ target }) => setConfirmPassword(target.value)}
          name="confirmPassword"
          type="password"
          required
        />
      </Form.Group>
      <Button type="submit" variant="primary" className="w-100">
        Restablecer Contraseña
      </Button>
    </Form>
  );
};

PasswordResetForm.propTypes = {
  hasLabel: PropTypes.bool
};

export default PasswordResetForm;
